import React, { useCallback } from 'react';
import { SortKeyType } from '../hooks/use-quote-table-sort';
import { SortableTableHead } from '@css-xp/base';

type QuotesTableSortableHeaderProps = {
  className?: string;
  columnName: string;
  selectedSortKey: SortKeyType;
  handleSorting: (sortKey: SortKeyType) => void;
  isAscending: boolean;
  shouldReverseSortIcon?: boolean;
  sortKey: SortKeyType;
};

export const QuotesTableSortableHeader = ({
  className,
  columnName,
  selectedSortKey,
  handleSorting,
  isAscending,
  shouldReverseSortIcon,
  sortKey,
}: QuotesTableSortableHeaderProps) => {
  const isAscSorted = selectedSortKey === sortKey ? isAscending : undefined;
  const handleSortingCallback = useCallback(() => {
    handleSorting(sortKey);
  }, [handleSorting, sortKey]);

  return (
    <SortableTableHead
      isAscSorted={isAscSorted}
      handleSorting={handleSortingCallback}
      columnName={columnName}
      className={className}
      shouldReverseSortIcon={shouldReverseSortIcon}
    />
  );
};
